module.exports = __webpack_public_path__ + "img/dworska_opal.aed825eb.jpg";